import type { PaletteColorOptions, ThemeOptions } from "@mui/material";
import { CovestroBreakpoints } from "./covestro-breakpoints";
import {
  CovestroBackgroundColor,
  CovestroColors,
  CovestroFontColor,
} from "./covestro-colors";
import { covestroMuiAutocomplete } from "./covestro-mui-autocomplete";
import {
  covestroMuiButton,
  covestroMuiButtonBase,
  covestroMuiButtonGroup,
} from "./covestro-mui-buttons";
import { covestroMuiCheckbox } from "./covestro-mui-checkbox";
import { covestroMuiFormHelperText } from "./covestro-mui-form";
import { covestroMuiRadio } from "./covestro-mui-radio";
import { covestroMuiSelect } from "./covestro-mui-select";
import { covestroMuiSwitch } from "./covestro-mui-switch";
import { covestroMuiTextField } from "./covestro-mui-textfield";
import { covestroMuiTooltip } from "./covestro-mui-tooltip";
import { covestroMuiTypography } from "./covestro-mui-typography";

export const createCovestroTheme = (
  primary: PaletteColorOptions = CovestroColors.cyan,
  secondary: PaletteColorOptions = CovestroColors.green,
): ThemeOptions => ({
  breakpoints: CovestroBreakpoints,
  shape: {
    borderRadius: 0,
  },
  palette: {
    text: {
      primary: CovestroFontColor,
    },
    background: {
      default: CovestroBackgroundColor,
    },
    primary: primary,
    secondary: secondary,
    ...CovestroColors,
    error: {
      light: "#EC4C4C",
      main: "#E50000",
      dark: "#A00000",
      contrastText: "#FFFFFF",
    },
  },
  components: {
    MuiButtonBase: covestroMuiButtonBase,
    MuiButton: covestroMuiButton,
    MuiButtonGroup: covestroMuiButtonGroup,
    MuiCheckbox: covestroMuiCheckbox,
    MuiRadio: covestroMuiRadio,
    MuiSwitch: covestroMuiSwitch,
    MuiTextField: covestroMuiTextField,
    MuiAutocomplete: covestroMuiAutocomplete,
    MuiSelect: covestroMuiSelect,
    MuiFormHelperText: covestroMuiFormHelperText,
    MuiTooltip: covestroMuiTooltip,
  },
});

export { covestroMuiTypography };
